import React, {useEffect, useContext, useState} from 'react'
import useFetch from '../../hooks/fetchMSSQL-hook'
import { useParams, Link } from 'react-router-dom/cjs/react-router-dom.min'
import { NavigationContext } from '../../context/navigation-context'
import link from '../../assets/images/back_to_list_icon.svg'
import ReportButton from '../../components/Buttons/ReportButton'

export default function DO() {
    const [DO, setDO] = useState([])
    const [items, setItems] = useState([])
    const [initialItems, setInitialItems] = useState([])
    const [sortBy, setSortBy] = useState("none")
    const { setHeaderData } = useContext(NavigationContext)
    const {fetchMssqlApi} = useFetch()
    const param = useParams()
    // console.log(param)

    const sortDefaults = {
        Name: "ASC",
        MachineFeederNo: "ASC",
        Quantity: "DESC"
    }

    const arrow = (field) => {
        const [currentField, currentDir] = String(sortBy || "").split("|")
        if (currentField !== field) return ""
        return String(currentDir || "").toUpperCase() === "ASC" ? " ▲" : " ▼"
    }

    const handleHeaderSort = (field) => {
        const [currentField, currentDirRaw] = String(sortBy || "").split("|")
        const currentDir = String(currentDirRaw || "").toUpperCase()

        let nextDir
        if (currentField === field) {
            nextDir = currentDir === "ASC" ? "DESC" : "ASC"
        } else {
            nextDir = sortDefaults[field] || "ASC"
        }

        const nextSortBy = `${field}|${nextDir}`
        setSortBy(nextSortBy)
        getDo(nextSortBy)
    }

    const getDo = (sort = sortBy) => {
        const query = sort && sort !== "none" ? `?sortBy=${encodeURIComponent(sort)}` : ""

        fetchMssqlApi(`dos/${param.id}${query}`, {}, res => {
            setDO(res[0])
            setInitialItems(res[1])
        })
    }

    // const getItems = () => fetchMssqlApi(`pa-pas/items/${param.id}`, {}, res => setInitialItems(res))
    useEffect(() => {
        setHeaderData({text: "Szczegóły doładowania"})
        getDo()
    }, [])

    useEffect(() => {
        setItems(initialItems)
    }, [initialItems])

    return (
        DO && (
        <div>
            <div className='container-xl'>
            {/* <Link to='/dos'>
                <button onClick={() => window.history.back()} className="btn btn-link ml-1 text-decoration-none mb-3">
                    <i className="fas fa-arrow-left mr-2" />
                    Wróć
                </button>
            </Link> */}
            <Link to='/dos'>
                    <label to='back' className="btn btn-link ml-1 text-decoration-none mb-3">
                        <img id='back' src={link}></img>
                    </label>
            </Link>
            <div className='card mb-4'>
                <div className='card-header d-flex justify-content-between'>
                    <h5 className='h5 mb-0'>
                        {DO.DO}
                    </h5 >
                    <div className='d-flex gap-2'>
                        <ReportButton reportId={74} btnColor="dark" isPrimary body={() => ({loadMachineInventoryId: param.id})}/>
                        <ReportButton reportId={70} btnColor="outline-dark" isPrimary body={() => ({loadMachineInventoryId: param.id})}/>
                    </div>
                </div>
                <div>
                    <table className="table table-striped">
                        <tbody>
                            <tr className='justify-content-center'>
                                <td className='text-center'>Stworzone</td>
                                <td className='text-center'>Automat</td>
                                <td className='text-center'>Ilość doładowania</td>
                            </tr>
                            <tr className='justify-content-center'>
                                <td>
                                    <div className='d-flex justify-content-center mb-1 mt-1'>
                                        {DO.Created}
                                    </div>
                                </td>
                                <td>
                                    <div className='d-flex justify-content-center mb-1 mt-1'>
                                        {DO.MachineFullName}
                                    </div>
                                </td>
                                <td>
                                    <div className='d-flex justify-content-center mb-1 mt-1'>
                                        {DO.UnloadQuantity}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {/* <div className='card-body'> */}
                </div>
                <div className='card'>
                    {items.length ?
                ( <table className="table table-striped ">
                    <thead>
                        <tr>
                            <th
                                style={{ cursor: "pointer", userSelect: "none" }}
                                onClick={() => handleHeaderSort("Name")}
                            >
                                Produkt{arrow("Name")}
                            </th>
                            <th
                                style={{ cursor: "pointer", userSelect: "none" }}
                                onClick={() => handleHeaderSort("MachineFeederNo")}
                            >
                                Nr sprężyny{arrow("MachineFeederNo")}
                            </th>
                            <th
                                style={{ cursor: "pointer", userSelect: "none" }}
                                onClick={() => handleHeaderSort("Quantity")}
                            >
                                Ilość{arrow("Quantity")}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, idx) => 
                        !item.deleted && 
                        (
                            <tr key={idx}>
                                <td>{item.Name}</td>
                                <td className='text-left'>{item.MachineFeederNo}</td>
                                <td>{item.Quantity}</td>
                            </tr>
                        ))}
                        
                    </tbody>
                    </table>)
                    : 
                    <div className='card'>
                    </div>
                }
                </div>
                
            </div>
        </div>
        )
    )
}